import React from 'react'
import Img from 'gatsby-image'
import CourseCard from './courseCard'
import { isNarrowDesktop } from '../../../media-queries'
import Fade from 'react-reveal/Fade'
import './index.css'

export default class CourseValues extends React.Component {
  state = {
    height: getHeight(),
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updateHeight)
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateHeight)
    }
  }

  setHeight = () => {
    this.setState({ height: getHeight() })
  }

  updateHeight = () => {
    if (!isNarrowDesktop()) {
      this.setHeight()
    }
  }

  render() {
    return (
      <div
        style={{
          ...this.props.style,
        }}
      >
        <Img
          style={{
            height: this.state.height * 0.75,
            marginTop: this.state.height * 0.25,
          }}
          sizes={this.props.image.sizes}
        />
        <div
          style={{
            float: 'left',
            position: 'absolute',
            zIndex: 110,
            marginTop: this.state.height * -0.95,
            width: '100vw',
          }}
        >
          <Fade bottom cascade>
            <div className={'homepage--course-values'}>
              {this.props.data.map((props, i) => {
                props.index = i
                return <CourseCard key={i} {...props} />
              })}
            </div>
          </Fade>
        </div>
      </div>
    )
  }
}

const getHeight = () => {
  if (window) {
    if (isNarrowDesktop()) return 750
    else return window.innerHeight - 45
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/courseValues/index.js